import { ReportInterface, ReportType } from "@/modules/reports/types";
import axios from "@/network";

export function apiGetSchedule(params: any, headers = {}) {
  const url = "/week_schedule";
  return axios.get(url, { params, headers });
}

export function apiGetAbsenceReports(params: any) {
  const url = "/reports";
  return axios.get(url, {
    params: {
      ...params,
      types: [ReportType.VACATION, ReportType.PARENTAL, ReportType.ABSENCE],
    },
  });
}

export async function apiGetAbsenceReportsAsync(params: any): Promise<Array<ReportInterface>> {
  const pageSize = 100;
  const firstResponse = await apiGetAbsenceReports({ ...params, page: 1, page_size: pageSize });
  const reports = firstResponse.data.data as Array<ReportInterface>;
  const lastPage = firstResponse.data.meta?.last_page || 1;

  for (let page = 2; page <= lastPage; page += 1) {
    const response = await apiGetAbsenceReports({ ...params, page, page_size: pageSize });
    reports.push(...(response.data.data as Array<ReportInterface>));
  }

  return reports;
}

export function apiGetKnowledgeDomains(userId: number) {
  const url = `/users/${userId}/knowledge_domains`;
  return axios.get(url, {
    params: {
      user_id: userId,
    },
  });
}
